import useSWR from 'swr'
import API from '../../utils/api'
import { getPersistData } from '../../app/hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/users/' // (5) 사용자 조회

let swrData: any = getPersistData(KEY)

export function useUserInfo(userId) {
	const { data: token } = useToken()
	const { data, mutate } = useSWR<any>(
		KEY + userId,
		async () => {
			const response = await API.get(KEY + userId, token + '', {})
			swrData = response.result?.result

			return swrData
		},
		{ revalidateOnFocus: true }
	)

	return {
		userInfo: data,
		mutate: (value?: any) => {
			if (value != undefined) {
				swrData = value
			}
			return mutate()
		},
	}
}